import {
  Box,
  Button,
  CircularProgress,
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  TextField,
  Typography,
  useTheme,
} from "@mui/material";
import RequiredAsterisk from "../../components/RequiredAsterisk/RequiredAsterisk";

const QuestionModal = ({
  open,
  onClose,
  onSave,
  formData,
  isEditing,
  setFormData,
  saving,
}) => {
  const theme = useTheme();

  return (
    <Dialog
      open={open}
      onClose={onClose}
      maxWidth="sm"
      fullWidth
      PaperProps={{
        sx: {
          borderRadius: 3,
          backgroundColor: theme.palette.background.paper,
          boxShadow:
            theme.palette.mode === "dark"
              ? "0px 8px 24px rgba(0, 0, 0, 0.5)"
              : "0px 8px 24px rgba(0, 0, 0, 0.15)",
        },
      }}
    >
      <DialogTitle sx={{ pb: 1, pt: 3, px: 3 }}>
        <Typography
          variant="h6"
          fontWeight={600}
          sx={{ color: theme.palette.text.primary }}
        >
          {isEditing ? "Edit Question" : "Add New Question"}
        </Typography>
        <Typography
          variant="body2"
          sx={{ color: theme.palette.text.secondary, mt: 0.5 }}
        >
          {isEditing
            ? "Update the question details below"
            : "Enter the question details below"}
        </Typography>
      </DialogTitle>
      <DialogContent sx={{ pt: 3, px: 3 }}>
        <Box>
          <Typography
            variant="caption"
            sx={{
              display: "block",
              mb: 0.5,
              color: theme.palette.text.secondary,
              fontWeight: 500,
              fontSize: "14px",
            }}
          >
            Question
            <RequiredAsterisk />
          </Typography>
          <TextField
            multiline
            rows={4}
            fullWidth
            value={formData.question}
            onChange={(e) =>
              setFormData({ ...formData, question: e.target.value })
            }
            placeholder="Enter the interview question here..."
            sx={{
              "& .MuiOutlinedInput-root": {
                borderRadius: 2,
                backgroundColor: theme.palette.background.paper,
                color: theme.palette.text.primary,
              },
              "& .MuiInputLabel-root": {
                color: theme.palette.text.secondary,
              },
              "& .MuiInputBase-input": {
                color: theme.palette.text.primary,
              },
              "& .MuiInputBase-input::placeholder": {
                color: theme.palette.text.secondary,
                opacity: 0.7,
              },
            }}
          />
        </Box>
      </DialogContent>
      <DialogActions sx={{ px: 3, pb: 3, pt: 2 }}>
        <Button
          variant="outlined"
          onClick={onClose}
          size="large"
          sx={{
            borderColor: theme.palette.divider,
            color: theme.palette.text.primary,
            "&:hover": {
              borderColor: theme.palette.text.secondary,
            },
          }}
          disabled={saving}
        >
          Cancel
        </Button>
        <Button
          size="large"
          onClick={onSave}
          variant="contained"
          disabled={saving || !formData?.question?.trim()}
          startIcon={
            saving ? <CircularProgress size={18} color="inherit" /> : null
          }
        >
          {saving
            ? isEditing
              ? "Updating..."
              : "Adding..."
            : isEditing
              ? "Update Question"
              : "Add Question"}
        </Button>
      </DialogActions>
    </Dialog>
  );
};

export default QuestionModal;
